import { NEW_RESET_PASSWORD_CLEAR_STATE } from '../../constants';
import { withType } from '../../../utils/actionOperations';

export const newResetPasswordClearState = () => {
    return dispatch => {
        dispatch(withType(NEW_RESET_PASSWORD_CLEAR_STATE));
    };
};